@if (({ data: (vm$ | async)}); as vmData) {
  <rask-toggle-panel
    #togglePanel
    label="Betalning"
    helpUrl="https://sveaskog.sharepoint.com/sites/Glantan/SiteCollectionDocuments/Virkesk%C3%B6p/Lathund%20F%C3%B6rskott%20och%20Betalplan.pdf"
    [showLoader]="!vmData.data"
    [defaultExpanded]="false">
    @if (vmData.data; as vm) {
      <div class="row">
        <div class="col-2">
          <rask-textmultiline
            class="mt-0"
            label="Betalningar KR">
            <b>{{ vm.betalningTotal | number: '1.0-0' }}</b>
          </rask-textmultiline>
        </div>
        <div class="col-3">
          <rask-textmultiline
            class="mt-0"
            label="% Av kontraktsbelopp">
            <b>{{ vm.kontraktsbeloppPercentage | number: '1.0-0' }}</b>
          </rask-textmultiline>
        </div>
        <div class="col-3">
          <rask-textmultiline
            class="mt-0"
            label="kontraktsbelopp kr">
            <b>{{ vm.kontraktsbelopp | number: '1.0-0' }}</b>
          </rask-textmultiline>
        </div>
        <div class="col-2">
            <rask-textmultiline
                class="mt-0"
                label="Total kostnad skogsvård kr">
                <b>{{totalkonstnadSkogsvard | number: '1.0-0'}}</b>
            </rask-textmultiline>
        </div>
      </div>
      @if (!virkeskopsKontrakt.isSkogsvardsKontrakt) {
        <div class="leverantor-container">
          <div class="betalning-table-header gray">
            <div class="namn-col label">
              Leverantör - Andel
            </div>
            <div class="betalning-col label">
              Betalningar kr
            </div>
            <div class="percent-col label">
              % av andel
            </div>
            <div class="total-col label">
              Andel kr
            </div>
          </div>
          @for (leverantor of vm.leverantorer; track trackByFn($index, leverantor)) {
            <rask-betalning-leverantor
              [leverantor]="leverantor">
            </rask-betalning-leverantor>
          }
        </div>
      }
       <rask-betalning-skogsvard></rask-betalning-skogsvard>
    }
  </rask-toggle-panel>
}